query CommunicationGroups(
  $first: Int
  $after: Cursor
  $orderBy: [CommunicationGroupsOrderBy!]
  $filter: CommunicationGroupFilter
  $communicationGroupItems: [CommunicationGroupItemsOrderBy!]
) {
  communicationGroups(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
    nodes {
      id
      _rowTimestamp
      name
      description
      _isUpdatable
      _isDeletable
      communicationGroupItemsByCommunicationGroupId(
        orderBy: $communicationGroupItems
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
        }
        totalCount
        nodes {
          id
          _rowTimestamp
          communicationChannelId
          _communicationChannelName
          isSenderOnly
          isRecipientOnly
          _isUpdatable
          _isDeletable
          communicationChannel {
            _isAlerts
          }
        }
      }
    }
  }
}
